import { Component, OnInit } from '@angular/core';
import { RoleDto } from 'src/app/models/RoleDto';
import { RolePermissionDto } from 'src/app/models/RolePermissionDto';
import { RolePermissionService } from 'src/app/services/role-permission.service';
import { RolesService } from 'src/app/services/roles.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemPermissionDto } from 'src/app/models/SystemPermission';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { PermissionRequest} from 'src/app/models/requests/new-permission';

@Component({
  selector: 'app-roleperms',
  templateUrl: './roleperms.component.html',
  styleUrls: ['./roleperms.component.css']
})
export class RolepermsComponent implements OnInit {

  selectedRoleId:number=0;
  selectedPermissionId:number=0;
  CanRead:boolean = false;
  CanAdd:boolean = false;
  CanEdit:boolean = false;
  CanDelete:boolean = false;
  CanApprove:boolean = false;
  CanTerminate:boolean=false;
  UpdatePermission:any;
  Roles:RoleDto[]=[];
  RolePermissions:RolePermissionDto[]=[];
  SystemPermissions:SystemPermissionDto[]=[]

  constructor(private roleService:RolesService, private rolePermService:RolePermissionService, 
    private modalService: NgbModal, private notification: NotificationService) { }

  ngOnInit(): void {
    this.loadRecoords();
  }


 async onOptionsSelected(value:any){
    let resRolesPerms = await this.rolePermService.getByRoleId(this.selectedRoleId).toPromise();
    this.RolePermissions = <RolePermissionDto[]>resRolesPerms.responseData;
}
  async loadRecoords() {

    let resRoles = await this.roleService.getRoles().toPromise();
    this.Roles = <RoleDto[]>resRoles.responseData;

    let resSPermission = await this.rolePermService.getPermissions().toPromise();
    this.SystemPermissions = <SystemPermissionDto[]>resSPermission.responseData;

  }

  onDelete(role: any, doDelete: any) {
 
  }

  async openModal(content:any) {
    this.modalService.open(content, { centered: true });
  }

  async openUpdateModal(update:any, data:any) {
    this.UpdatePermission = data;
    this.modalService.open(update, { centered: true });
  }

  addPermission(): void {
    let permissionRequest: PermissionRequest = {
      roleId:this.selectedRoleId,
      permissionId:this.selectedPermissionId,
      canAdd:this.CanAdd,
      canEdit:this.CanEdit,
      canDelete: this.CanDelete,
      canRead: this.CanRead,
      canApprove : this.CanApprove,
      canTerminate:this.CanTerminate
    };

    this.rolePermService.addPermission(permissionRequest).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Location Created successfully ${data}`);
          this.modalService.dismissAll();
          window.location.reload();

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  updatePermission(): void {
    
    this.rolePermService.updatePermission(this.UpdatePermission).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Permission Updated successfully ${data}`);
          this.modalService.dismissAll();

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
